import { useLingui } from '@lingui/react';
import { TextInput } from '@mantine/core';
import { Icons } from '../Shares/Icons';
import classes from './SearchInput.module.css';
export const SearchInput: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <TextInput placeholder={i18n._('search')} rightSection={<Icons className="icon-pr-line-search" fontSize={24} />} radius={5} size="md" h={46} bg="var(--striped-bg-color)" classNames={classes} style={{
    flexGrow: 1
  }} />;
};